import { useEffect, useState } from "react";
import { getGroupInfoLeadre } from "../../api/group";
import DashboardGroup from "./dashboard/dashboardGroup";

export default function DashboardTrip() {
  const [dataGroup, setDataGroup] = useState();
  useEffect(() => {
    getGroupInfoLeadre()
      .then((x) => setDataGroup(x))
      .catch(() => {});
  }, []);
  return (
    <>
      <DashboardGroup leader data={dataGroup} />
    </>
  );
}
